import { Avatar, Stack } from "@mui/material";
import femmeJulia from "../../assets/images/femme_julia.png";

export default function Question(props: any) {
    const question = props.question;
    return (
        <div>
            <Stack direction={"row"} gap={1} alignItems={"center"}>
                <Avatar alt="Femme Julia" src={femmeJulia} sx={{ width: 56, height: 56 }} />
                <p className='century-bold'>Julia</p>
            </Stack>
            {question}
        </div>
    );
};
